import {createSelector} from 'reselect';

const makersSelector = (state) => state.makers;
             
export const getMakers = createSelector(
    [makersSelector],
    state => state.list
);